export default "__VITE_ASSET___GD5z$0j__"